import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const replaceLegacyScheduleLabels = () => {
  if (typeof document === 'undefined') return;

  const replacements = new Map([
    ['Powered by 40 Bags (Live ESPN Schedule)', 'Powered by 40 Bags · Live Schedule Data'],
    ['Live ESPN Data', 'Live Schedule Data'],
    ['Fetching live schedule data from ESPN...', 'Fetching live schedule data...'],
  ]);

  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode(node) {
        return replacements.has(node.nodeValue?.trim())
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      },
    }
  );

  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(node => {
    const current = node.nodeValue?.trim();
    if (replacements.has(current)) {
      node.nodeValue = node.nodeValue.replace(current, replacements.get(current));
    }
  });
};

// Register a basic service worker for PWA install prompt support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    try {
      navigator.serviceWorker.register('/sw.js');
    } catch {}
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Keep user-facing schedule language provider-neutral while schedule providers
// evolve behind the 40 Bags data layer.
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(replaceLegacyScheduleLabels);
  observer.observe(document.body, { childList: true, subtree: true });
  replaceLegacyScheduleLabels();
}
